// Convierte un objeto con potencial anidamiento de datos a un formato clave-valor
export function toKeyValue(str) {
  return convertToJSON(str);
}

function convertToJSON(json) {
  json = JSON.parse(JSON.stringify(json));
  const tipoDato = Array.isArray(json) ? "Array" : typeof json;
  let datos = [];

  if (tipoDato === "Array") {
    datos = ifList(json);
  } else if (tipoDato === "object") {
    datos = ifObject(json);
  }
  return datos;
}

function ifList(list) {
  const tipoDato = Array.isArray(list) ? "Array" : typeof list;
  let tipoDatoS = "";

  if (tipoDato === "Array" && list.length > 0) {
    tipoDatoS = Array.isArray(list[0]) ? "Array" : typeof list[0];
  }

  let datos = Array.isArray(list) ? [] : {};

  if (
    tipoDato === "Array" &&
    tipoDatoS === "object" &&
    list[0]["Detalle"] === undefined
  ) {
    datos = {};
    list.forEach((item) => {
      datos[item["Nombre"]] = item["Valor"];
      if (item["Detalle"] !== undefined)
        datos["Detalle"] = ifList(item["Detalle"]);
    });
  } else if (tipoDato === "Array") {
    list.forEach((item) => {
      datos.push(ifList(item));
    });
  } else if (tipoDato === "object") {
    datos = ifObject(list);
  }

  return datos;
}

function ifObject(obj) {
  //const tipoDato = typeof obj;
  let datos = [];
  if (Array.isArray(obj)) {
    datos = ifList(obj);
  } else {
    if (obj["Detalle"] !== undefined) {
      datos = {
        [obj["Nombre"]]: obj["Valor"],
        Detalle: ifObject(obj["Detalle"]),
      };
    } else {
      datos = { [obj["Nombre"]]: obj["Valor"] };
    }
  }
  return datos;
}

export { convertToJSON };

export function columnasToKeyValue(data) {
  if (!Array.isArray(data)) return [];

  return data.map((item) => {
    const obj = {};

    if (Array.isArray(item.columnasField)) {
      item.columnasField.forEach((col) => {
        obj[col.campoField] = col.valorField;
      });
    }

    return obj;
  });
}

export function formatCurrency(value) {
  const number = parseFloat(value);
  if (isNaN(number)) {
    return value;
  }
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(number)
    .replace("US$", "");
}

export function normalizeText(text) {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function levenshteinDistance(a, b) {
  const dp = Array.from({ length: a.length + 1 }, (_, i) =>
    Array(b.length + 1).fill(i),
  );

  for (let j = 1; j <= b.length; j++) dp[0][j] = j;

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      dp[i][j] =
        a[i - 1] === b[j - 1]
          ? dp[i - 1][j - 1]
          : Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]) + 1;
    }
  }

  return dp[a.length][b.length];
}

export function similarityPercentage(a, b) {
  const maxLen = Math.max(a.length, b.length);
  if (maxLen === 0) return 100;

  const distance = levenshteinDistance(a, b);
  return ((maxLen - distance) / maxLen) * 100;
}

export function convertToNumber(value) {
  try {
    if (!value || typeof value !== "string") return 0.0;
    return Number(value.replace(/[^\d.-]/g, ""));
  } catch (e) {
    return 0.0;
  }
}

export function toBoolean(value) {
  if (typeof value === "boolean") {
    return value;
  }

  if (value == null) {
    return false;
  }

  if (typeof value === "number") {
    return value !== 0;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();

    const trueValues = ["true", "1", "yes", "y", "si", "sí", "on"];
    const falseValues = ["false", "0", "no", "n", "off", ""];

    if (trueValues.includes(normalized)) {
      return true;
    }

    if (falseValues.includes(normalized)) {
      return false;
    }
  }

  return Boolean(value);
}
